import React, { useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { Form, Select } from 'antd';
import { Box, makeStyles, Tooltip } from '@material-ui/core';
import { CurrencyDisplayModeEnum } from '../../../../../constant';

const CurrencyModeSelect = () => {
  const classes = useStyles();
  const t = useTranslate();
  const form = Form.useFormInstance();
  const currency = Form.useWatch('currency', form);

  const currencyModeChoices = [
    {
      value: CurrencyDisplayModeEnum.NORMAL,
      label: t('resources.brand.text.normalDisplayed'),
    },
    ...(currency?.isThinEnabled
      ? [
          {
            value: CurrencyDisplayModeEnum.THIN,
            label: t('resources.brand.text.prefixedDisplayed'),
          },
        ]
      : []),
  ];

  const isDisabled = typeof currency?.isThinEnabled !== 'boolean';

  useEffect(() => {
    if (!currency?.isThinEnabled && form.getFieldValue('mode') === CurrencyDisplayModeEnum.THIN) {
      form.resetFields(['mode']);
    }
  }, [currency]);

  return (
    <Tooltip
      title={isDisabled ? t('resources.brand.chooseCurrencyFirst') : undefined}
      placement="top-start"
      disableInteractive={!isDisabled}
      disableHoverListener={!isDisabled}
      disableTouchListener={!isDisabled}
      disableFocusListener={!isDisabled}
    >
      <Box>
        <Form.Item name="mode">
          <Select
            placement="bottomLeft"
            options={currencyModeChoices}
            placeholder={t('resources.brand.fields.currencyMode')}
            disabled={isDisabled}
            className={classes.input}
          />
        </Form.Item>
      </Box>
    </Tooltip>
  );
};

export default CurrencyModeSelect;

const useStyles = makeStyles({
  input: {
    minWidth: 200,
  },
});
